import { render, staticRenderFns } from "./Stamp.vue?vue&type=template&id=bba39a56&scoped=true"
import script from "./Stamp.vue?vue&type=script&setup=true&lang=js"
export * from "./Stamp.vue?vue&type=script&setup=true&lang=js"
import style0 from "./Stamp.vue?vue&type=style&index=0&id=bba39a56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../account/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bba39a56",
  null
  
)

export default component.exports